// src/utils/axios.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://pulseback.greenafricafarm.com/api/"
      : "http://localhost:4000/api/"),
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    if (!navigator.onLine) {
      return Promise.reject(new Error("You are offline."));
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!navigator.onLine) {
      return Promise.reject(new Error("You are offline."));
    }
    
    // Automatically log the user out if their JWT is expired or invalid
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("customer");
      localStorage.removeItem("token");
      
      // Prevent infinite redirect loops if they are already on login page
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    
    return Promise.reject(error);
  },
);

export default axiosInstance;
